<script>
	import PosterText from 'component/PosterText.svelte'
	import { img_prefix } from 'shared/var'
	export let groups, promo_active
</script>

<div class="desktop_home_buttons">
	{#each groups.filter(g => promo_active ? g.enabled_desktop_during_promo : g.enabled_desktop) as g, i}
		<a href="{g.url}">
			<div class="fixed-aspect-ratio-container">
				<img src="{img_prefix}/{encodeURI(g.sets.Portrait.pick)}?auto=format,compress&w=260&fit=fill" alt="" style="animation-duration: {16 + (Math.random() * 10)}s;" class="{i % 2 ? `up` : `down`}" />
				<PosterText>
					{g.name}
				</PosterText>
			</div>
		</a>
	{/each}
</div>

<style>
	.desktop_home_buttons {
		display: flex;
	}

	a {
		flex-grow: 1;
	}

	.fixed-aspect-ratio-container {
		position: relative;
		padding-bottom: 260%;
		overflow: hidden;
		background: #000;
		font-size: 3rem;
	}

	a :global(.poster_text) {
		--background-color: transparent !important;
	}

	a:hover :global(.poster_text) {
		--text-color: #ceff51;
		--background-color: black !important;
	}

	@media (max-width: 1040px) {
		a {
			font-size: 5vw;
		}
	}

	img {
		filter: saturate(1.2) brightness(0.8) contrast(0.8);
		transition: .1s filter ease-in-out;
		position: absolute;
		top: 0;
		-webkit-animation-duration: 3s;
		animation-duration: 3s;
		-webkit-animation-iteration-count: infinite;
		animation-iteration-count: infinite;
		-webkit-animation-direction: alternate;
		animation-direction: alternate;
		-webkit-animation-timing-function: ease-in-out;
		animation-timing-function: ease-in-out;
	}

	a:hover img {
		filter: saturate(1) brightness(1) contrast(1);
	}

	.desktop_home_buttons:hover a:not(:hover) img {
		filter: saturate(1.2) brightness(.6) contrast(0.7);
	}

	img.up {
		-webkit-animation-name: up;
		animation-name: up;
	}

	img.down {
		-webkit-animation-name: down;
		animation-name: down;
	}

	@keyframes up {
		from {
			transform: translate(0, -10%);
		}

		to {
			transform: translate(0, 0);
		}
	}

	@keyframes down {
		from {
			transform: translate(0, 0);
		}

		to {
			transform: translate(0, -10%);
		}
	}
</style>
